import { SingleOfferBannerController } from "./single-offer-banner.controller";

const singleOfferBannerComponent = {
	bindings: {},
	template: require("./external-single-offer-banner.html"),
	controller: SingleOfferBannerController,
	controllerAs: "sobc",
};

export default singleOfferBannerComponent;